import {
  Button,
  Card,
  Container,
  Grid,
  IconButton,
  Stack,
  Tooltip,
  Typography
} from "@mui/material";
import React, { useEffect, useState } from "react";
import LeadStatusInsertUpdateModal from "./leadStatusInsertUpdateModal";
import { getAttributeListApi } from "src/api/commonapi";
import DataTable from "react-data-table-component";
import { EditSharp } from "@mui/icons-material";

export default function Index() {
  const [addEditModal, setAddEditModal] = useState(false);
  const [modalType, setModalType] = useState("Add");
  const [rowData, setRowData] = useState([]);
  const [statusList, setStatusList] = useState([]);

  const toggleAddEditModal = () => setAddEditModal(!addEditModal);

  const handleGetAttributeList = async () => {
    const resp = await getAttributeListApi();
    if (resp.status == 1) {
      setStatusList(resp.data);
    }
  };

  const columns = [
    { name: "No", selector: (row, index) => index + 1, width: "70px" },
    {
      name: "Status Name",
      wrap: true,
      selector: (row) => row?.name,
      sortable: true
    },
    {
      name: "Action",
      wrap: true,
      width: "150px",
      cell: (row) => (
        <>
          <button
            onClick={() => {
              setModalType("Edit");
              setRowData(row);
              setAddEditModal(true);
              // getOptionsValueList(row.mgt_for_type);
              // setfileimage();
            }}
            style={{ background: "none", border: "none", padding: 0, cursor: "pointer" }}
          >
            <Tooltip title="Edit">
              <IconButton>
                <EditSharp color="warning" />
              </IconButton>
            </Tooltip>
          </button>
        </>
      )
    }
  ];

  const ExpandableRow = ({ data }) => {
    return (
      <div style={{ padding: "5px 15px", backgroundColor: "#f3f3f39c" }}>
        <p>
          <b>Description</b> : {data?.description}
        </p>
      </div>
    );
  };

  useEffect(() => {
    handleGetAttributeList();
  }, []);
  return (
    <>
      <Container>
        <Grid container spacing={2}>
          <Grid item xs={10}>
            <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
              <Typography variant="h4" gutterBottom>
                Lead Status
              </Typography>
            </Stack>
          </Grid>
        </Grid>

        <Card spacing={3} style={{ padding: "10px", marginTop: "20px" }}>
          <DataTable
            pagination
            highlightOnHover
            columns={columns}
            data={statusList != null ? statusList : []}
            expandableRows
            expandableRowsComponent={ExpandableRow}
          />
        </Card>
      </Container>
      {addEditModal && (
        <LeadStatusInsertUpdateModal
          addEditModal={addEditModal}
          setAddEditModal={setAddEditModal}
          toggleAddEditModal={toggleAddEditModal}
          modalType={modalType}
          rowData={rowData}
          handleGetAttributeList={handleGetAttributeList}
        />
      )}
    </>
  );
}
